import { createFileRoute } from "@tanstack/react-router";
import { Button } from "@timeghost/ui/shadcn/button";
import { type JSX, useState } from "react";
import { useTranslation } from "react-i18next";
import ExternalLinkDialog from "@/components/overlays/external-link-dialog";
import BoxedPage from "@/components/shell/boxed-page";
import { POWER_AUTOMATE_CONNECTOR_URL } from "@/lib/automation/power-automate";

const AutomationPage = (): JSX.Element => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(true);

	return (
		<BoxedPage description={t("automation.pageDescription")} title={t("nav.automation")}>
			<Button onClick={() => setOpen(true)} type="button">
				{t("automation.openConnector")}
			</Button>
			<ExternalLinkDialog href={POWER_AUTOMATE_CONNECTOR_URL} onOpenChange={setOpen} open={open} />
		</BoxedPage>
	);
};

export const Route = createFileRoute("/_app/automation/")({
	component: AutomationPage,
});
